/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react';
import classNames from 'classnames/bind';
import { RegistrationContext } from '../../../../../contexts';
import { RegistrationActions } from '../../../../../contexts/RegistrationContext/RegistrationReducer';
import { monthlyPriceEnum } from '../../../../../shared/kids-recurring-donation';
import styles from './styles.module.scss';
import { useRegistrationData } from '../../../../../hooks';
import { StaticUrls } from '../../../../../shared/static-urls-enum';

const cx = classNames.bind(styles);

const { UPDATE_REGISTRATION_STATE } = RegistrationActions;

const Donation = () => {
  const [registerState, registerDispatch] = useContext(RegistrationContext);
  const { donationAmount } = registerState || {};

  const { registrationClosed } = useRegistrationData();

  return (
    <div>
      {!registrationClosed ? (
        <div>
          <div className={cx('donation-text', 'row col-md-9 pt-4 p-2 m-2')}>
            <div>
              Help us unlock the power of play! Support our Volo Kids Foundation&nbsp; and make a
              difference today. Donate now or{' '}
              <a href={StaticUrls.VOLOKIDS_VOLUNTEER} target="_blank" rel="noopener noreferrer">
                learn how to get involved
              </a>{' '}
              as a volunteer coach
            </div>
          </div>
          <div className={cx('donationContainer')}>
            {monthlyPriceEnum.map(({ price, text }) => (
              <div key={price}>
                <div
                  role="button"
                  tabIndex={0}
                  onClick={() =>
                    registerDispatch({
                      type: UPDATE_REGISTRATION_STATE,
                      update: {
                        donationAmount: price,
                        customDonation: false,
                      },
                    })
                  }
                  className={cx('donationCircle', donationAmount === price && 'selected')}
                >
                  <h3>${price / 100}</h3>
                  <div className={cx('donationText', 'flex-grow-1')}>
                    <p>{text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Donation;
